import type { AccountingKind, OrderStatus, SyncStatus } from "@/api/types";
import { Badge } from "@/components/crm/Badge";

const ORDER: Record<OrderStatus, { label: string; tone: "neutral" | "brand" | "ok" | "danger" | "warn" }> = {
  on_hold: { label: "On credit hold", tone: "danger" },
  confirmed: { label: "Confirmed", tone: "brand" }, partially_delivered: { label: "Part delivered", tone: "warn" },
  delivered: { label: "Delivered", tone: "ok" }, cancelled: { label: "Cancelled", tone: "danger" },
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return <Badge tone={ORDER[status].tone}>{ORDER[status].label}</Badge>;
}

export const SYSTEM_NAMES: Record<AccountingKind, string> = {
  tally: "Tally", zoho_books: "Zoho Books", quickbooks: "QuickBooks", xero: "Xero", odoo: "Odoo",
};

export function SyncBadge({ status, target }: { status: SyncStatus; target: AccountingKind | null }) {
  const system = target ? SYSTEM_NAMES[target] : "accounts";
  if (status === "synced") return <Badge tone="ok">In {system}</Badge>;
  if (status === "queued") return <Badge tone="brand">Sending to {system}</Badge>;
  if (status === "failed") return <Badge tone="danger">{system} failed</Badge>;
  return <Badge>Not in accounts</Badge>;
}
